/**
 * MEAL CYCLE - MODELOS DE DATOS v2.3
 * Fuente única de verdad para todas las entidades del sistema
 * ✅ CORREGIDO: Sin duplicados de 'despensa' en CATEGORIES
 */

// ============================================
// CATEGORÍAS DE PRODUCTOS (15 categorías)
// ============================================

export const CATEGORIES = {
  BEBIDAS: 'bebidas',
  CARNES: 'carnes',
  CEREALES: 'cereales y harinas',
  CONGELADOS: 'congelados',
  DESPENSA: 'despensa',
  FIAMBRES: 'fiambres',
  FRUTAS: 'frutas',
  HIGIENE: 'higiene personal',
  HUEVOS: 'huevos',
  LACTEOS: 'lácteos',
  LEGUMBRES: 'legumbres',
  LIMPIEZA: 'limpieza del hogar',
  MASCOTAS: 'mascotas',
  SNACKS: 'snacks y golosinas',
  VERDURAS: 'verduras'
  
  // ⚠️ NO agregar aliases aquí - usar mapOldCategory() en su lugar
};

export const CATEGORY_LIST = [
  'bebidas',
  'carnes',
  'cereales y harinas',
  'congelados',
  'despensa',
  'fiambres',
  'frutas',
  'higiene personal',
  'huevos',
  'lácteos',
  'legumbres',
  'limpieza del hogar',
  'mascotas',
  'snacks y golosinas',
  'verduras'
];

export const CATEGORY_LABELS = {
  'bebidas': 'Bebidas',
  'carnes': 'Carnes',
  'cereales y harinas': 'Cereales y Harinas',
  'congelados': 'Congelados',
  'despensa': 'Despensa',
  'fiambres': 'Fiambres',
  'frutas': 'Frutas',
  'higiene personal': 'Higiene Personal',
  'huevos': 'Huevos',
  'lácteos': 'Lácteos',
  'legumbres': 'Legumbres',
  'limpieza del hogar': 'Limpieza del Hogar',
  'mascotas': 'Mascotas',
  'snacks y golosinas': 'Snacks y Golosinas',
  'verduras': 'Verduras'
};

export const CATEGORY_ICONS = {
  'bebidas': '🥤',
  'carnes': '🥩',
  'cereales y harinas': '🌾',
  'congelados': '❄️',
  'despensa': '🥫',
  'fiambres': '🥓',
  'frutas': '🍎',
  'higiene personal': '🧼',
  'huevos': '🥚',
  'lácteos': '🥛',
  'legumbres': '🫘',
  'limpieza del hogar': '🧹',
  'mascotas': '🐶',
  'snacks y golosinas': '🍫',
  'verduras': '🥬'
};

// ✅ Mapeo de categorías viejas → nuevas (para migración)
export const mapOldCategory = (oldCategory) => {
  if (!oldCategory) return 'despensa';
  
  const normalized = oldCategory.toLowerCase().trim();
  
  const mapping = {
    'verduras': 'verduras',
    'carnes': 'carnes',
    'lácteos': 'lácteos',
    'lacteos': 'lácteos',
    'cereales': 'cereales y harinas',
    'frutas': 'frutas',
    'huevos': 'huevos',
    'congelados': 'congelados',
    'fiambres': 'fiambres',
    'bebidas': 'bebidas',
    'legumbres': 'legumbres',
    'snacks': 'snacks y golosinas',
    'higiene': 'higiene personal',
    'limpieza': 'limpieza del hogar',
    'mascotas': 'mascotas',
    'otros': 'despensa',      // ✅ Mapeo aquí, no en CATEGORIES
    'aderezos': 'despensa'    // ✅ Mapeo aquí, no en CATEGORIES
  };
  
  return mapping[normalized] || 'despensa';
};

export const normalizeCategory = (category) => {
  if (!category) return 'despensa';
  const normalized = category.toLowerCase().trim();
  if (CATEGORY_LIST.includes(normalized)) return normalized;
  return mapOldCategory(normalized);
};

// ============================================
// UNIDADES DE MEDIDA
// ============================================

export const UNITS = {
  KG: 'kg',
  G: 'g',
  L: 'l',
  ML: 'ml',
  UNIDAD: 'unidad',
  PAQUETE: 'paquete', 
  CAJA: 'caja'
};

export const UNIT_LABELS = {
  [UNITS.KG]: 'Kilogramos',
  [UNITS.G]: 'Gramos',
  [UNITS.L]: 'Litros',
  [UNITS.ML]: 'Mililitros',
  [UNITS.UNIDAD]: 'Unidades'
};

export const COMPATIBLE_UNITS = {
  [UNITS.KG]: [UNITS.G],
  [UNITS.G]: [UNITS.KG],
  [UNITS.L]: [UNITS.ML],
  [UNITS.ML]: [UNITS.L]
};

// ============================================
// 🆕 TIPOS DE COMPONENTES (12 categorías)
// ============================================

export const COMPONENT_TYPES = {
  PRINCIPALES: 'principales',          // 🍖 Proteínas principales
  GUARNICIONES: 'guarniciones',        // 🥗 Acompañamientos calientes
  GUISOS: 'guisos',                    // 🍲 Guisos y estofados argentinos
  PASTAS: 'pastas',                    // 🍝 Pastas y ñoquis
  TARTAS_EMPANADAS: 'tartas y empanadas', // 🥟 Masas rellenas
  ENSALADAS: 'ensaladas',              // 🥬 Ensaladas y vegetales crudos
  SALSAS: 'salsas',                    // 🥫 Salsas y aderezos
  PANES: 'panes',                      // 🍞 Panes y facturas
  SOPAS: 'sopas',                      // 🍜 Sopas y caldos
  POSTRES: 'postres',                  // 🍰 Postres y dulces
  BEBIDAS: 'bebidas',                  // 🥤 Bebidas y licuados
  EXTRAS: 'extras'                     // ➕ Complementos adicionales
};

export const COMPONENT_TYPE_LIST = [
  'bebidas',
  'ensaladas',
  'extras',
  'guarniciones',
  'guisos',
  'panes',
  'pastas',
  'postres',
  'principales',
  'salsas',
  'sopas',
  'tartas y empanadas'
];

export const COMPONENT_TYPE_LABELS = {
  'bebidas': 'Bebidas',
  'ensaladas': 'Ensaladas',
  'extras': 'Extras',
  'guarniciones': 'Guarniciones',
  'guisos': 'Guisos y Estofados',
  'panes': 'Panes y Facturas',
  'pastas': 'Pastas',
  'postres': 'Postres',
  'principales': 'Principales',
  'salsas': 'Salsas y Aderezos',
  'sopas': 'Sopas y Caldos',
  'tartas y empanadas': 'Tartas y Empanadas'
};

export const COMPONENT_TYPE_ICONS = {
  'bebidas': '🥤',
  'ensaladas': '🥬',
  'extras': '➕',
  'guarniciones': '🥗',
  'guisos': '🍲',
  'panes': '🍞',
  'pastas': '🍝',
  'postres': '🍰',
  'principales': '🍖',
  'salsas': '🥫',
  'sopas': '🍜',
  'tartas y empanadas': '🥟'
};

export const COMPONENT_TYPE_COLORS = {
  'bebidas': 'from-sky-500 to-blue-500',
  'ensaladas': 'from-lime-500 to-green-500',
  'extras': 'from-gray-500 to-slate-500',
  'guarniciones': 'from-green-500 to-emerald-500',
  'guisos': 'from-orange-600 to-amber-600',
  'panes': 'from-yellow-600 to-orange-400',
  'pastas': 'from-yellow-500 to-amber-500',
  'postres': 'from-pink-500 to-rose-500',
  'principales': 'from-red-500 to-orange-500',
  'salsas': 'from-purple-500 to-pink-500',
  'sopas': 'from-cyan-500 to-blue-500',
  'tartas y empanadas': 'from-amber-500 to-orange-500'
};

// 🔄 Migración de tipos viejos
export const migrateComponentType = (oldType) => {
  if (!oldType) return 'principales';
  
  const normalized = oldType.toLowerCase().trim();
  
  const mapping = {
    'principal': 'principales',
    'guarnicion': 'guarniciones',
    'extra': 'extras',
    'base': 'pastas',
    'bases': 'pastas'
  };
  
  return mapping[normalized] || normalized;
};

export const normalizeComponentType = (type) => {
  if (!type) return 'principales';
  const normalized = type.toLowerCase().trim();
  if (COMPONENT_TYPE_LIST.includes(normalized)) return normalized;
  return migrateComponentType(normalized);
};

// ============================================
// EJEMPLOS DE COMPONENTES ARGENTINOS
// ============================================

export const SAMPLE_COMPONENTS_ARG = {
  principales: [
    'Milanesa de carne',
    'Asado de tira',
    'Vacío al horno',
    'Pollo al horno',
    'Suprema Maryland',
    'Bife de chorizo',
    'Hamburguesas caseras',
    'Matambre a la pizza'
  ],
  guarniciones: [
    'Puré de papa',
    'Papas fritas',
    'Papas noisette',
    'Batatas asadas',
    'Calabaza al horno',
    'Arroz blanco',
    'Verduras grilladas'
  ],
  guisos: [
    'Guiso de lentejas',
    'Guiso de arroz',
    'Locro',
    'Puchero',
    'Carbonada',
    'Estofado de carne',
    'Guiso de mondongo'
  ],
  pastas: [
    'Fideos con manteca',
    'Ñoquis de papa',
    'Ravioles de ricota',
    'Sorrentinos',
    'Tallarines',
    'Canelones de verdura',
    'Lasagna'
  ],
  'tartas y empanadas': [
    'Empanadas de carne',
    'Empanadas de pollo',
    'Tarta de verdura',
    'Tarta de jamón y queso',
    'Pascualina',
    'Empanadas de humita'
  ],
  ensaladas: [
    'Ensalada mixta',
    'Ensalada rusa',
    'Ensalada criolla',
    'Ensalada de tomate',
    'Ensalada verde',
    'Ensalada caesar'
  ],
  salsas: [
    'Salsa criolla',
    'Chimichurri',
    'Salsa golf',
    'Salsa blanca',
    'Salsa de tomate',
    'Mayonesa casera',
    'Provenzal'
  ],
  panes: [
    'Pan casero',
    'Medialunas',
    'Facturas',
    'Pan de ajo',
    'Galletas de campo',
    'Tortitas negras'
  ],
  sopas: [
    'Sopa de verduras',
    'Caldo de gallina',
    'Sopa de calabaza',
    'Sopa de tomate',
    'Crema de choclo'
  ],
  postres: [
    'Flan casero',
    'Arroz con leche',
    'Budín de pan',
    'Ensalada de frutas',
    'Vigilante (queso y dulce)',
    'Panqueques con dulce de leche'
  ],
  bebidas: [
    'Limonada',
    'Mate cocido',
    'Licuado de banana',
    'Jugo de naranja natural',
    'Té helado'
  ],
  extras: [
    'Pan rallado',
    'Huevo duro',
    'Aceitunas',
    'Pickles',
    'Crutones'
  ]
};

// ============================================
// TIPOS DE COMIDAS DEL DÍA
// ============================================

export const MEAL_TYPES = {
  BREAKFAST: 'breakfast',
  LUNCH: 'lunch',
  SNACK: 'snack',
  DINNER: 'dinner'
};

export const MEAL_TYPE_LABELS = {
  [MEAL_TYPES.BREAKFAST]: 'Desayuno',
  [MEAL_TYPES.LUNCH]: 'Almuerzo',
  [MEAL_TYPES.SNACK]: 'Merienda',
  [MEAL_TYPES.DINNER]: 'Cena'
};

export const MEAL_TYPE_ICONS = {
  [MEAL_TYPES.BREAKFAST]: '☕',
  [MEAL_TYPES.LUNCH]: '🌞',
  [MEAL_TYPES.SNACK]: '🍪',
  [MEAL_TYPES.DINNER]: '🌙'
};

// ============================================
// TIPOS DE ORIGEN DE COMIDA
// ============================================

export const MEAL_SOURCE_TYPE = {
  RECIPE: 'recipe',
  COMBO: 'combo',
  MANUAL: 'manual'
};

export const MEAL_SOURCE_TYPE_LABELS = {
  [MEAL_SOURCE_TYPE.RECIPE]: 'Receta Guardada',
  [MEAL_SOURCE_TYPE.COMBO]: 'Combo Temporal',
  [MEAL_SOURCE_TYPE.MANUAL]: 'Manual'
};

export const MEAL_SOURCE_TYPE_ICONS = {
  [MEAL_SOURCE_TYPE.RECIPE]: '📖',
  [MEAL_SOURCE_TYPE.COMBO]: '🧩',
  [MEAL_SOURCE_TYPE.MANUAL]: '✍️'
};

// ============================================
// ESTADOS DE COMIDA
// ============================================

export const MEAL_STATUS = {
  PLANNED: 'planned',
  COOKED: 'cooked',
  CANCELLED: 'cancelled',
  EMPTY: 'empty'
};

export const MEAL_STATUS_LABELS = {
  [MEAL_STATUS.PLANNED]: 'Pendiente',
  [MEAL_STATUS.COOKED]: 'Cocinado',
  [MEAL_STATUS.CANCELLED]: 'Cancelado',
  [MEAL_STATUS.EMPTY]: 'Sin planificar'
};

export const MEAL_STATUS_COLORS = {
  [MEAL_STATUS.PLANNED]: {
    bg: 'bg-blue-50',
    border: 'border-blue-300',
    text: 'text-blue-800',
    badge: 'bg-blue-600'
  },
  [MEAL_STATUS.COOKED]: {
    bg: 'bg-green-50',
    border: 'border-green-300',
    text: 'text-green-800',
    badge: 'bg-green-600'
  },
  [MEAL_STATUS.CANCELLED]: {
    bg: 'bg-gray-50',
    border: 'border-gray-300',
    text: 'text-gray-600',
    badge: 'bg-gray-600'
  },
  [MEAL_STATUS.EMPTY]: {
    bg: 'bg-gray-50',
    border: 'border-gray-200 border-dashed',
    text: 'text-gray-400',
    badge: 'bg-gray-400'
  }
};

// ============================================
// REGLAS DE NEGOCIO
// ============================================

export const BUSINESS_RULES = {
  NEVER_NEGATIVE_STOCK: 'El stock nunca puede ser negativo',
  STOCK_IS_SOURCE_OF_TRUTH: 'El stock real es la fuente de verdad',
  CATEGORIES_MANDATORY: 'Todo alimento debe tener categoría',
  COMPATIBLE_UNITS_ONLY: 'Solo se permiten unidades compatibles',
  PLANNER_IS_SOURCE: 'El planificador es la fuente de verdad para compras',
  NO_AUTO_DEDUCT: 'Nunca se descuenta automáticamente por fecha',
  EXPLICIT_CONFIRMATION: 'Cocinar requiere confirmación explícita',
  SHOW_BEFORE_DEDUCT: 'Mostrar qué se descontará antes de confirmar',
  SINGLE_DEDUCT: 'Cada comida se descuenta solo una vez',
  COMPONENTS_ARE_REUSABLE: 'Los componentes son bloques reutilizables',
  RECIPES_USE_COMPONENTS: 'Las recetas solo referencian componentes',
  COMBOS_NOT_SAVED: 'Los combos temporales no se guardan como receta',
  INGREDIENTS_FROM_COMPONENTS: 'Los ingredientes vienen de componentes',
  SHOPPING_IS_DERIVED: 'La lista de compras es derivada, no fuente',
  ONLY_MISSING_ITEMS: 'Solo se listan ingredientes faltantes',
  EXCLUDE_COOKED: 'No incluir comidas ya cocinadas',
  PRE_STOCK_ADJUSTMENT: 'Permitir ajuste antes de agregar al stock',
  UNDO_COOK_ALLOWED: 'Se puede deshacer "cocinado"',
  UNDO_NO_RESTORE_STOCK: 'Deshacer NO devuelve ingredientes al stock',
  CONFIRM_DESTRUCTIVE: 'Acciones destructivas requieren confirmación'
};

// ============================================
// VALIDADORES
// ============================================

export const validators = {
  isValidCategory: (category) => {
    if (!category) return false;
    const normalized = normalizeCategory(category);
    return CATEGORY_LIST.includes(normalized);
  },
  
  isValidUnit: (unit) => Object.values(UNITS).includes(unit),
  
  isPositiveNumber: (value) => typeof value === 'number' && value > 0,
  
  isValidDate: (dateStr) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateStr)) return false;
    const date = new Date(dateStr);
    return !isNaN(date.getTime());
  },
  
  areUnitsCompatible: (unit1, unit2) => {
    if (unit1 === unit2) return true;
    return COMPATIBLE_UNITS[unit1]?.includes(unit2) || false;
  },
  
  isValidMealSourceType: (type) => Object.values(MEAL_SOURCE_TYPE).includes(type),
  
  isValidMealType: (type) => Object.values(MEAL_TYPES).includes(type),
  
  isValidComponentType: (type) => {
    if (!type) return false;
    const normalized = normalizeComponentType(type);
    return COMPONENT_TYPE_LIST.includes(normalized);
  }
};

// ============================================
// CONVERSORES DE UNIDADES
// ============================================

export const unitConverters = {
  convert: (value, fromUnit, toUnit) => {
    if (fromUnit === toUnit) return value;
    
    if (fromUnit === UNITS.KG && toUnit === UNITS.G) return value * 1000;
    if (fromUnit === UNITS.G && toUnit === UNITS.KG) return value / 1000;
    if (fromUnit === UNITS.L && toUnit === UNITS.ML) return value * 1000;
    if (fromUnit === UNITS.ML && toUnit === UNITS.L) return value / 1000;
    
    throw new Error(`No se puede convertir de ${fromUnit} a ${toUnit}`);
  }
};

console.log('✅ Types v2.3 cargado - 15 categorías + 12 tipos de componentes (sin duplicados)');